'use strict';

exports.__esModule = true;

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypingEffect = function TypingEffect(_ref) {
	var message = _ref.message,
	    speed = _ref.speed,
	    _ref$eraseSpeed = _ref.eraseSpeed,
	    eraseSpeed = _ref$eraseSpeed === undefined ? 50 : _ref$eraseSpeed,
	    _ref$shouldErase = _ref.shouldErase,
	    shouldErase = _ref$shouldErase === undefined ? false : _ref$shouldErase,
	    _ref$onTypingComplete = _ref.onTypingComplete,
	    onTypingComplete = _ref$onTypingComplete === undefined ? function () {} : _ref$onTypingComplete,
	    _ref$showTypingIndica = _ref.showTypingIndicator,
	    showTypingIndicator = _ref$showTypingIndica === undefined ? false : _ref$showTypingIndica,
	    _ref$onWhileTyping = _ref.onWhileTyping,
	    onWhileTyping = _ref$onWhileTyping === undefined ? function () {} : _ref$onWhileTyping,
	    _ref$onWhileTypingDel = _ref.onWhileTypingDelay,
	    onWhileTypingDelay = _ref$onWhileTypingDel === undefined ? 1500 : _ref$onWhileTypingDel,
	    _ref$showTypingEffect = _ref.showTypingEffect,
	    showTypingEffect = _ref$showTypingEffect === undefined ? true : _ref$showTypingEffect;

	var _useState = (0, _react.useState)(''),
	    currentMessage = _useState[0],
	    setCurrentMessage = _useState[1];

	var _useState2 = (0, _react.useState)(true),
	    typing = _useState2[0],
	    setTyping = _useState2[1];

	var _useState3 = (0, _react.useState)(false),
	    executeOnWhileTyping = _useState3[0],
	    setExecuteOnWhileTyping = _useState3[1];

	(0, _react.useEffect)(function () {
		var timer = void 0;
		if (typing) {
			timer = setTimeout(function () {
				setCurrentMessage(message.slice(0, currentMessage.length + 1));
				if (currentMessage.length === message.length) {
					setTyping(false);
					if (shouldErase) {
						setTimeout(function () {
							setTyping(true);
							setCurrentMessage('');
						}, eraseSpeed);
					}
					onTypingComplete();
				}
			}, speed);
		}
		return function () {
			return clearTimeout(timer);
		};
	}, [currentMessage, message, speed, typing, eraseSpeed, shouldErase]);

	(0, _react.useEffect)(function () {
		if (message !== currentMessage) {
			if (showTypingEffect) {
				setCurrentMessage('');
				setTyping(true);
			} else {
				setCurrentMessage(message);
			}
		}
	}, [message]);

	(0, _react.useEffect)(function () {
		if (executeOnWhileTyping && (typing || !showTypingEffect)) {
			onWhileTyping();
			setExecuteOnWhileTyping(false);
		}
		var timer = setTimeout(function () {
			setExecuteOnWhileTyping(true);
		}, onWhileTypingDelay);

		return function () {
			return clearTimeout(timer);
		};
	}, [executeOnWhileTyping, typing]);

	var typingIndicator = '<span style={{ visibility: ' + (typing ? 'visible' : 'hidden') + ' }}>|</span>';

	return _react2.default.createElement('div', {
		className: '--typing-effect-message',
		dangerouslySetInnerHTML: {
			__html: currentMessage + (showTypingIndicator ? typingIndicator : '')
		}
	});
};

TypingEffect.propTypes = {
	message: _types2.default.string,
	speed: _types2.default.number,
	eraseSpeed: _types2.default.number,
	shouldErase: _types2.default.bool,
	onTypingComplete: _types2.default.func,
	showTypingIndicator: _types2.default.bool,
	onWhileTyping: _types2.default.func,
	onWhileTypingDelay: _types2.default.number,
	showTypingEffect: _types2.default.bool
};

exports.default = _react2.default.memo(TypingEffect);